var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPsLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.6 54.4",
    style: {
      enableBackground: "new 0 0 99.6 54.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n\t.st1{fill:#EF4651;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,17.1c-1.1,0.8-2.4,1.3-3.9,1.3c-3.4,0-6.1-2.7-6.1-6s2.8-6,6.1-6c1.5,0,2.8,0.5,3.9,1.3l1.3-1.3 c-1.4-1.2-3.2-1.9-5.2-1.9c-4.4,0-8,3.5-8,7.8s3.6,7.8,8,7.8c2,0,3.8-0.7,5.2-1.9L77.2,17.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.6,30.9c0.6,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2S52.9,30.9,53.6,30.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 33.1,
    className: "st1",
    width: 1.8,
    height: 15.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,12.4c0-4.3-3.4-7.7-7.5-7.7c-2.2,0-4.3,1-5.7,2.7V4.7H0.1v21.2h1.8v-8.3c1.4,1.7,3.5,2.7,5.7,2.7 C11.7,20.2,15.1,16.7,15.1,12.4z M7.5,18.4c-3.1,0-5.6-2.5-5.7-5.7v-0.2c0-3.3,2.6-5.9,5.7-5.9s5.7,2.7,5.7,5.9S10.7,18.4,7.5,18.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,48.7c2.2,0,4.3-1,5.7-2.7v2.7h1.8V33.1h-1.8v2.7c-1.4-1.7-3.5-2.7-5.7-2.7c-4.1,0-7.5,3.5-7.5,7.7 C14.4,45.2,17.8,48.7,21.9,48.7z M16.2,40.9c0-3.3,2.6-5.9,5.7-5.9s5.7,2.7,5.7,5.9v0.2c-0.1,3.2-2.6,5.7-5.7,5.7 C18.8,46.9,16.2,44.2,16.2,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.3,40.9c0-4.3-3.4-7.7-7.5-7.7c-2.2,0-4.3,1-5.7,2.7v-2.7h-1.8v21.2h1.8v-8.3c1.4,1.7,3.5,2.7,5.7,2.7 C45.9,48.7,49.3,45.2,49.3,40.9z M41.8,46.9c-3.1,0-5.6-2.5-5.7-5.7V41c0-3.3,2.6-5.9,5.7-5.9s5.7,2.7,5.7,5.9 C47.5,44.2,44.9,46.9,41.8,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,4.6v9.2c0,2.5-2,4.5-4.6,4.6c-2.5,0-4.5-2-4.5-4.6V4.6h-1.8v9.2c0,3.5,2.8,6.4,6.3,6.4s6.4-2.9,6.4-6.4 V4.6H28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,4.6c-2.2,0-4.3,1-5.7,2.7V0h-1.8v20.2h1.8v-2.7c1.4,1.7,3.5,2.7,5.7,2.7c4.1,0,7.5-3.5,7.5-7.7 C49.3,8.1,45.9,4.6,41.8,4.6z M47.5,12.5c0,3.3-2.6,5.9-5.7,5.9s-5.7-2.7-5.7-5.9v-0.2c0.1-3.2,2.6-5.7,5.7-5.7 C44.9,6.5,47.5,9.2,47.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.8,2.4c0.6,0,1.2-0.5,1.2-1.2S61.5,0,60.8,0c-0.6,0-1.2,0.5-1.2,1.2S60.1,2.4,60.8,2.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 4.6,
    className: "st0",
    width: 1.8,
    height: 15.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.7,2.4c0.6,0,1.2-0.5,1.2-1.2S84.4,0,83.7,0c-0.6,0-1.2,0.5-1.2,1.2S83,2.4,83.7,2.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.8,
    y: 4.6,
    className: "st0",
    width: 1.8,
    height: 15.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.5,33.1c-1.7,0-3.4,0.7-4.6,2v-2h-1.8v15.6h1.8v-9.2C79,37,81,35,83.5,35s4.5,2,4.5,4.5v9.2h1.8v-9.2 C89.9,36,87,33.1,83.5,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.4,46.9h-0.2c-0.2,0-0.5,0.1-0.9,0.1c-0.7,0-1.1-0.5-1.1-1.6V34.8h2.2V33h-2.2v-5.2h-1.9V33h-2.2v1.8h2.2 v10.7c0,1.2,0.2,1.9,0.7,2.4c0.4,0.5,1.1,0.7,1.8,0.7c0.6,0,1.1-0.1,1.5-0.2h0.1V46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.7,44.2c-1,1.7-2.8,2.7-4.8,2.7c-3,0-5.5-2.4-5.7-5.5h12.3c0.5,0,0.9-0.4,0.9-0.8v-0.1 c-0.3-4.1-3.5-7.2-7.5-7.2c-4.2,0-7.6,3.5-7.6,7.8s3.4,7.7,7.6,7.7c2.5,0,4.9-1.3,6.3-3.5L70.7,44.2z M66,35c2.7,0,5,1.9,5.5,4.6 H60.3C61,36.9,63.2,35,66,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,41.2c0,0-0.5-0.4-1-0.6c-0.5-0.2-1.2-0.5-2.8-0.8c-0.2-0.1-0.4-0.1-0.6-0.1c-1-0.3-1.8-0.6-2.4-1 c-0.6-0.5-0.8-0.9-0.8-1.4c0-0.6,0.4-1.1,1-1.6c0.7-0.5,1.7-0.8,2.8-0.7c1.3,0.1,2.3,0.7,3.3,1.5l0.1,0.1l1.3-1.2 c-0.2-0.2-0.2-0.2-0.6-0.5c-1-0.7-2.3-1.5-4.1-1.5c-1.5-0.1-2.8,0.2-3.9,0.9c-1.1,0.8-1.8,1.9-1.8,3c0,0.9,0.2,1.7,1,2.5 c1,1,2.7,1.5,4.1,1.8c1.3,0.2,2.4,0.7,3,1.2c0.7,0.6,1,1.1,1,1.8c0,0.6-0.5,1.3-1.2,1.7c-0.7,0.5-1.8,0.8-2.8,0.8 c-1.4-0.1-2.9-0.7-4.4-1.8l-0.1-0.1L0,46.4l0.1,0.1c1.7,1.5,3.6,2.3,5.6,2.4c1.5,0.1,2.8-0.3,3.9-1.1c1.2-0.8,1.9-1.9,1.9-3.1 C11.9,43.2,11.2,42,10.2,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.2,12.7c0,0-0.5-0.4-1-0.6c-0.5-0.2-1.2-0.5-2.8-0.8c-0.2-0.1-0.4-0.1-0.6-0.1c-1-0.3-1.8-0.6-2.4-1 c-0.6-0.5-0.8-0.9-0.8-1.4c0-0.6,0.4-1.1,1-1.6c0.7-0.5,1.7-0.8,2.8-0.7c1.3,0.1,2.3,0.7,3.3,1.5l0.1,0.1l1.3-1.2 c-0.2-0.2-0.2-0.2-0.6-0.5c-1-0.7-2.3-1.5-4.1-1.5c-1.5-0.1-2.8,0.2-3.9,0.9c-1.1,0.8-1.8,1.9-1.8,3c0,0.9,0.2,1.7,1,2.5 c1,1,2.7,1.5,4.1,1.8c1.3,0.2,2.4,0.7,3,1.2c0.7,0.6,1,1.1,1,1.8c0,0.6-0.5,1.3-1.2,1.7c-0.7,0.5-1.8,0.8-2.8,0.8 c-1.4-0.1-2.9-0.7-4.4-1.8l-0.1-0.1L88,17.9l0.1,0.1c1.7,1.5,3.6,2.3,5.6,2.4c1.5,0.1,2.8-0.3,3.9-1.1c1.2-0.8,1.9-1.9,1.9-3.1 C99.9,14.7,99.3,13.5,98.2,12.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 0.1,
    className: "st0",
    width: 1.8,
    height: 20.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsLogoNew);
export default __webpack_public_path__ + "static/media/ps-logo-NEW.eba26f8db57816e060c7b66b4366425c.svg";
export { ForwardRef as ReactComponent };